import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { mediaQueries } from 'plugins/device'
import {
  Card,
  TextCallout1,
  TextSubHeading,
  Link,
  IconNoImage,
  colors,
  TextBody,
} from '@blocket/blocket-ui'
import { getImageSrcSet } from 'utils/imageSrcSetTypes'
import staticFilesUrl from 'constants/staticFiles'

const CardsWrapper = styled.ol`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  grid-auto-rows: 1fr;
  margin: 16px 0px 20px;
  @media ${mediaQueries.medium} {
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    margin-bottom: 40px;
  }
`

const AdCard = styled(Card)`
  padding: 16px;
`

const AdSubject = styled(TextBody)`
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 4px;
`

const AdLocation = styled(TextCallout1)`
  color: ${colors.grey700};
`

const AdPrice = styled(TextSubHeading)`
  line-height: 20px;
`

const ImageWrapper = styled.div`
  height: 120px;
  width: auto;
  background-color: ${colors.grey100};
  border-radius: 4px;
  margin-bottom: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  @media ${mediaQueries.medium} {
    height: 200px;
  }
`

const Image = styled.img`
  height: 100%;
  width: 100%;
  object-fit: contain;
`

const AdsCards = ({ ads }) => {
  const [needsDefaultImage, setNeedsDefaultImg] = useState([])
  const defaultImage = `${staticFilesUrl}/assets/images/no-image.svg`

  return (
    <CardsWrapper>
      {ads.map((ad, index) => {
        const found = needsDefaultImage.find((number) => number === index)
        const useDefaultImage = found !== undefined
        return (
          <li key={ad.adId}>
            <Link to={ad.adUrl}>
              <AdCard>
                <ImageWrapper>
                  {ad.imageUrl ? (
                    <Image
                      srcSet={useDefaultImage ? defaultImage : getImageSrcSet(ad.imageUrl)}
                      onError={() => setNeedsDefaultImg([...needsDefaultImage, index])}
                      alt="annonsbild"
                    />
                  ) : (
                    <IconNoImage width="60%" height="60%" color={colors.grey300} />
                  )}
                </ImageWrapper>
                <AdLocation>{ad.region}</AdLocation>
                <AdSubject>{ad.subject}</AdSubject>
                <AdPrice>{ad.price}</AdPrice>
              </AdCard>
            </Link>
          </li>
        )
      })}
    </CardsWrapper>
  )
}

AdsCards.propTypes = {
  ads: PropTypes.array.isRequired,
}

export default AdsCards
